var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripletexEmblem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.9 38",
    style: {
      enableBackground: "new 0 0 25.9 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#58B3CD;}\n\t.st1{fill:#1AB96D;}\n\t.st2{fill:#010A59;}\n ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.5,19.6v-1.1h6.4c-0.1-1.6-0.8-3.1-2-4.2c-1.1-1.1-2.5-1.8-4.1-2c-1.5-0.2-3.1,0.2-4.4,1 c-1.3,0.8-2.3,2.1-2.8,3.5c-0.5,1.5-0.5,3.1,0.1,4.5s1.5,2.7,2.9,3.5c1.3,0.8,2.9,1.1,4.4,0.9c1.5-0.2,3-0.9,4-2.1 c1.1-1.1,1.7-2.6,1.8-4.1L19.5,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.5,31.5h1.1V38c1.6-0.1,3.1-0.8,4.2-2c1.1-1.1,1.8-2.5,2-4.1c0.2-1.6-0.2-3.1-1-4.4 c-0.8-1.3-2.1-2.3-3.5-2.8c-1.5-0.5-3.1-0.5-4.5,0.1c-1.5,0.5-2.7,1.6-3.5,2.9c-0.8,1.3-1.1,2.9-0.9,4.5c0.2,1.5,0.9,3,2.1,4.1 c1.1,1.1,2.6,1.7,4.1,1.9L6.5,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.5,6.9L6.7,6.1l4.6-4.5C9.9,0.5,8.2-0.1,6.4,0S3,0.9,1.8,2.2C0.6,3.5,0,5.2,0,6.9c0,1.8,0.8,3.4,2,4.7 c1.2,1.2,2.9,2,4.7,2c1.8,0,3.5-0.6,4.8-1.8c1.3-1.2,2.1-2.8,2.2-4.6c0.1-1.7-0.5-3.5-1.6-4.8L7.5,6.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripletexEmblem);
export default __webpack_public_path__ + "static/media/tripletex-emblem.2b53e42cc7d6bf5046850fe03d603a60.svg";
export { ForwardRef as ReactComponent };